// src/termsConfig.js
export const CURRENT_TERMS_VERSION = "1.0";
export const CURRENT_TERMS_EFFECTIVE = "2025-10-11";